// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".transaction_transactions__l2Q8Q  tr:hover { \n        background: #EFEFEF !important ;\n        /* display: none; */\n    }\n", "",{"version":3,"sources":["webpack://./src/pages/Transaction/transaction.module.css"],"names":[],"mappings":"AAAA;QACQ,+BAA+B;QAC/B,mBAAmB;IACvB","sourcesContent":[".transactions  tr:hover { \n        background: #EFEFEF !important ;\n        /* display: none; */\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"transactions": "transaction_transactions__l2Q8Q"
};
export default ___CSS_LOADER_EXPORT___;
